/** @jsx jsx */
import { jsx, css } from '@emotion/react';

import { N20, N800, R500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import PropsLayoutRenderer, { PropTable } from './props-table';

const propsStyles = css({
  marginTop: token('space.200', '16px'),
  marginBottom: token('space.600', '48px'),
  '&:last-child': {
    marginBottom: token('space.0', '0px'),
  },
  'h3 > code:last-of-type': {
    /* Styles the 'required' prop text. Should be removed as soon as pretty-proptypes supports custom colours / tokens:
  https://product-fabric.atlassian.net/browse/DSP-3249 */
    color: token('color.text.danger', R500),
  },
  'h3 > code:first-of-type': {
    /* Styles the prop name heading */
    backgroundColor: token('color.background.neutral', N20),
    color: token('color.text', N800),
  },
});

/**
 * This gets imported in two places:
 *   1. Top-level component pages
 *   2. Sub-level component pages
 *
 * By having a wrapper we can have a single source of truth for both locations.
 */
const Props = (props: any) => {
  return (
    <div css={propsStyles}>
      <PropsLayoutRenderer {...props} />
    </div>
  );
};

export const TSMorphProps = ({
  props,
}: {
  props: {
    name: string;
    required: boolean;
    description: string;
    type: string;
    typeValue?: string;
    defaultValue?: string;
    deprecated: boolean;
  }[];
}) => {
  return (
    <div css={propsStyles}>
      {props
        .filter((prop) => {
          if (prop.description) {
            // Exclude internally marked props.
            return !prop.description.includes('@internal');
          }

          return true;
        })
        .map(
          ({
            description,
            name,
            deprecated,
            required,
            type,
            defaultValue,
            typeValue,
          }) => (
            <PropTable
              key={name}
              deprecated={deprecated}
              description={description}
              name={name}
              required={required}
              type={type}
              defaultValue={defaultValue}
              typeValue={typeValue}
            />
          ),
        )}
    </div>
  );
};

export default Props;
